import { Pipe, PipeTransform } from '@angular/core'
import { getNivelProgramaByKey } from 'src/app/shared/enums/nivel-programa.enum'

@Pipe({
  standalone: true,
  name: 'nivelPrograma',
})
export class NivelProgramaPipe implements PipeTransform {
  transform(value: string): string {
    return getNivelProgramaByKey(value)
  }
}
